import { FontVariantTheme } from './types';

const variants: FontVariantTheme = {
    h1: {
        fontSize: '48px',
        fontWeight: 'Light',
        lineHeight: '57px',
        letterSpacing: '0',
        marginBottom: '0'
    },
    h2: {
        fontSize: '25px',
        fontWeight: 'Medium',
        lineHeight: '29px',
        letterSpacing: '0',
        marginBottom: '18px'
    },
    h3: {
        fontSize: '20px',
        fontWeight: 'Regular',
        lineHeight: '24px',
        letterSpacing: '0',
        marginBottom: '10px'
    },
    h4: {
        fontSize: '18px',
        fontWeight: 'Regular',
        lineHeight: '20px',
        letterSpacing: '0',
        marginBottom: '0'
    },
    h5: {
        fontSize: '16px',
        fontWeight: 'Medium',
        lineHeight: '19px',
        letterSpacing: '0',
        marginBottom: '0'
    },
    h6: {
        fontSize: '16px',
        fontWeight: 'Regular',
        lineHeight: '19px',
        letterSpacing: '0',
        marginBottom: '0'
    },
    p: {
        fontSize: '16px',
        fontWeight: 'Light',
        lineHeight: '18px',
        letterSpacing: '0',
        marginBottom: '0'
    },
    button1: {
        fontSize: '1.6rem',
        fontWeight: 'Medium',
        lineHeight: '2.6rem',
        letterSpacing: '0rem',
        marginBottom: '0'
    },
    text1: {
        fontSize: '1.75rem',
        fontWeight: 'Light',
        lineHeight: '2.25rem',
        letterSpacing: '0'
    },
    welcometext: {
        fontSize: '40px',
        fontWeight: 'Light',
        lineHeight: '47px',
        letterSpacing: '0',
        marginBottom: '23px'
    },
    text2: {
        fontSize: '21px',
        letterSpacing: '0',
        lineHeight: '30px',
        marginBottom: '4px'
    },
    text3: {
        fontSize: '16px',
        letterSpacing: '0',
        fontWeight: 'Light',
        lineHeight: '24px'
    },
    text4: {
        fontSize: '24px',
        fontWeight: 'Strong',
        lineHeight: '24px',
        letterSpacing: '0',
        marginBottom: '15px'
    },
    amounttext: {
        fontSize: '36px',
        fontWeight: 'Light',
        lineHeight: '42px',
        letterSpacing: '0'
    },
    modalheadertext: {
        fontSize: '24px',
        fontWeight: 'Medium',
        lineHeight: '28px',
        letterSpacing: '0'
    }
};

export default variants;
